import React, { useState } from "react";
import AccountModal from "./AccountModal";
import NoAccountFoundLoader from "../../../../../../assets/images/noaccountsloaderbc.gif";
import Account from "./Account";
import { t } from "../../../../../utils/i18n";

const Body = ({ bankAccounts, deleteAccount }) => {
  return (
    <tbody className="bankaccountspage-tablebody">
      {bankAccounts.map((account, i) => (
        <Account
          account={account}
          key={account.id}
          deleteAccount={deleteAccount}
          index={i}
        />
      ))}
      {bankAccounts.length === 0 && (
          <p className="bankaccountspage-noaccount-loader">
            <img src={NoAccountFoundLoader} width="500" alt={t("p2p.common.no_accounts_found")} />
          </p>
      )}
    </tbody>
  );
};

export default Body;
